/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import axios from 'axios';
import { NetworkContext } from '../types/network';
import { clearAuthToken, updateAuthToken } from './auth';

const logout = async (ctx?: NetworkContext) => {
  if (typeof window !== 'undefined') {
    await axios.post('/api/logout');
    window.location.reload();
  } else {
    await clearAuthToken(ctx);
    await updateAuthToken({ logout: true }, ctx);
  }
};

export default logout;
